import React, { Component } from 'react'
import { Dropdown, ButtonGroup } from 'react-bootstrap';

import { Http } from '../../../../support';
import LoadingButton from '../../../../facturotopia/LoadingButton';
import ResponseError from '../../../../shared/responses/ResponseError';
import ResponseResult from '../../../../shared/responses/ResponseResult';

class CancelacionesTicketListItemActions extends Component {

  state = {
    busy: false,
    showConfirm: false
  }

  handleOnCancelActionClick = () => {
    this.setState({
      showConfirm: true
    });
  }

  handleRetryRequest = async () => {
    this.setState({
      busy: true
    });

    try {
      const params = {
        tickets: this.props.retryRequestRows.map((value) => {
          return value.id;
        })
      }

      const response = await Http.post(`/api/cancelaciones/retry`, params);

      this.setState({
        result: response,
        busy: false
      });
    } catch (error) {
      this.setState({
        error: error.data || error,
        busy: false
      });
    }
  }

  handleOnAction = (action) => {
    this.setState({
      result: undefined,
      error: undefined
    });
  }

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={ error }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  renderResult = () => {
    const { result } = this.state;

    return (
      <div className="result-container">
        <ResponseResult
          title="Solicitud aceptada"
          result={ result }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  render() {
    const { alignRight } = this.props;
    const { busy, error, result } = this.state;

    return (
      <>
        { error && this.renderError() }
        { result && this.renderResult() }

        <Dropdown as={ ButtonGroup } alignRight={ alignRight }>
          <LoadingButton
            variant="secondary"
            loading={ busy }
            onClick={ this.handleRetryRequest }
          >
            { busy === true ? 'Procesando' : 'Reintentar' }
          </LoadingButton>
        </Dropdown>
      </>
    )
  }
}

export default CancelacionesTicketListItemActions;